import { useState } from 'react';
// style
import style from './about.module.css';
// icon
import { FaRegCircleCheck } from 'react-icons/fa6';

const About = ({ aboutData }) => {
  const [isActive, setActive] = useState(1);

  return (
    <section className={style.section}>
      <div className="container">
        <div className={style.content}>
          {/* left */}
          <div className={style.left}>
            <div className="title">
              <h2 className={style.before}>{aboutData.title}</h2>
              <p className={style.text}>{aboutData.desc}</p>
            </div>
            <div className={style.desc}>
              <span>Сценарии:</span>
              <ul>
                {aboutData.detal.map((item) => (
                  <li key={item.id}>
                    <FaRegCircleCheck className={style.icon} />
                    {item.title}
                  </li>
                ))}
              </ul>
            </div>
            {/* <div className={style.desc}>
              <span>Идеально подходит:</span>
              <ul>
                <li>
                  <FaRegCircleCheck className={style.icon} />
                  Детские праздники
                </li>
                <li>
                  <FaRegCircleCheck className={style.icon} />
                  Молодежные компании
                </li>
                <li>
                  <FaRegCircleCheck className={style.icon} />
                  Корпоративы
                </li>
                <li>
                  <FaRegCircleCheck className={style.icon} />
                  Семейный отдых
                </li>
              </ul>
            </div> */}
          </div>
          {/* right */}
          <div className={style.right}>
            <img
              src={`../imgs/games/${aboutData.img1}`}
              alt="spartakzn"
              className={isActive == 1 ? style.active : false}
              onClick={() => setActive(1)}
            />
            <img
              src={`../imgs/games/${aboutData.img2}`}
              alt="spartakzn"
              className={isActive == 2 ? style.active : false}
              onClick={() => setActive(2)}
            />
          </div>
        </div>

        <div className={style.desc}></div>
      </div>
    </section>
  );
};
export default About;
